import { render, staticRenderFns } from "./HeaderBanner.vue?vue&type=template&id=479b07be"
import script from "./HeaderBanner.vue?vue&type=script&lang=js"
export * from "./HeaderBanner.vue?vue&type=script&lang=js"
import style0 from "./HeaderBanner.vue?vue&type=style&index=0&id=479b07be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports